import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ModalId, ModalsSliceState } from './modals.type';

const getTriggerElementId = (element: HTMLElement): string | null => {
  if (!element) {
    return null;
  }

  if (element.tagName === 'BUTTON') {
    // A soft reference is required because the context menu is not a child of the button, it is portaled in
    return element.role === 'menuitem'
      ? element.dataset['triggerElementId'] || null
      : element.id;
  }
  return getTriggerElementId(element.parentElement as HTMLElement);
};

export const getInitialState = (): ModalsSliceState => ({
  current: null,
  triggerElementId: null,
});

export const modalsSlice = createSlice({
  name: 'modals',
  initialState: () => getInitialState(),
  reducers: {
    openModal: (state, action: PayloadAction<ModalId>) => {
      state.current = action.payload;
      state.triggerElementId = getTriggerElementId(
        document.activeElement as HTMLElement,
      );
    },
    closeModal: (state, action: PayloadAction<ModalId>) => {
      if (state.current === action.payload) {
        state.current = null;
      }
    },
    closeAnyModal: (state) => {
      if (state.current !== null) {
        state.current = null;
      }
    },
    clearTriggerElementId: (state) => {
      state.triggerElementId = null;
    },
  },
});

export const { openModal, closeModal, closeAnyModal, clearTriggerElementId } =
  modalsSlice.actions;
